import { Button, Card, Collapse, Form, Input, InputNumber, Select, Space, Switch } from 'antd';
import { t } from '@lingui/core/macro';
import React, { Fragment, useEffect, useState } from 'react';
import ApiService from '../services/ApiService';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { Trans } from '@lingui/react/macro';
import { isMobile } from 'react-device-detect';

const {Option} = Select;


export default function CampagneAddonForm({name,campagneId,defaultOpen,showDisplayField}){
	const [campagneData, setCampagneData] = useState({});

	const getCampagneData = async () => {
		const res=await ApiService.get("/campagnes/"+campagneId)
		console.log("CampagneAddonForm",res)
		if(res.success){
			setCampagneData(res.data)
		}
	}

	useEffect(()=>{
		getCampagneData()
	},[campagneId])

	if(name===null){
		name=[]
	}

	if(!Array.isArray(name)){
		name=[name];
	}

	let _props={}
	if(defaultOpen){
		_props["defaultActiveKey"]=0
	}

	return(
		<Fragment>
			<Collapse forceRender style={{marginBottom: 20}} {..._props}>
				<Collapse.Panel key={0} forceRender header={t`Campagne`}>

					<Form.Item
						label={t`Nom qui apparaitra`}
						name={[name, "displayName"].flat()}
					>
						<Input placeholder={t`Vide = "Anonyme"`}
							   autoComplete="given-name family-name"/>
					</Form.Item>

					<Form.Item
						label={t`Equipe`}
						name={[name, "team"].flat()}
					>
						<Select placeholder={t`Equipe`}>
							<Option value={null}>{t`Sans Equipe`}</Option>
							{campagneData?.teams?.map(i => (
								<Option value={i.param}>{i.label}</Option>
							))}
						</Select>
					</Form.Item>

					<Form.Item
						label={t`Source`}
						name={[name, "source"].flat()}
					>
						<Select placeholder={t`Source`}>
							<Option value={null}>{t`Sans Source`}</Option>
							{campagneData?.sources?.map(i => (
								<Option value={i.param}>{i.label}</Option>
							))}
						</Select>
					</Form.Item>

					{showDisplayField &&(
						<Form.Item
							label={t`Afficher sur la page de campagne`}
							name={[name, "display"].flat()}
							valuePropName="checked"
						>
							<Switch />
						</Form.Item>
					)}


					{/*campagneData?.tombola &&(
						<Card title={t`Produits`} type={"inner"}>
							<Form.List name={[name,"products"].flat()}>
								{(fields, { add, remove }) => (
									<div>
										{fields.map((f) => (
											<Space size={"large"} key={f.name} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
												<Form.Item name={[f.name, "id"].flat()} label={t`Produit`} required>
													<Select style={{width:isMobile?"100%":200}} placeholder={t`Choisir un produit`}>
														{campagneData.products.filter(item => {
															const selected = form.getFieldValue("dettes") || [];
															const alreadyChosen = selected.some((d, i) => d?.id === item.id && i !== name);
															return !alreadyChosen;
														}).map(i => (
															<Select.Option value={i.id}>{i.name}</Select.Option>
														))}
													</Select>
												</Form.Item>

												<Form.Item name={[f.name, "quantity"].flat()} label={t`Quantité`} required>
													<InputNumber min={1} step={1}/>
												</Form.Item>

												<MinusCircleOutlined onClick={() => remove(f.name)} />
											</Space>
										))}
										<Form.Item>
											<Button type="dashed" onClick={() => add({quantity:1})} block icon={<PlusOutlined />}>
												<Trans>Ajouter un produit</Trans>
											</Button>
										</Form.Item>
									</div>
								)}
							</Form.List>
						</Card>
					)*/}

				</Collapse.Panel>
			</Collapse>
		</Fragment>
	)
}